import script from "./EditConnection.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditConnection.vue?vue&type=script&lang=ts&setup=true"

import "./EditConnection.vue?vue&type=style&index=0&id=51841654&lang=scss"

const __exports__ = script;

export default __exports__